// File automatically generated by `vite-plugin-module-list`
export default [
  {
    path: "views/APIClientListView.js",
    module: () => import("./views/APIClientListView.js"),
  },
  { path: "views/Account.js", module: () => import("./views/Account.js") },
  {
    path: "views/AccountError.js",
    module: () => import("./views/AccountError.js"),
  },
  {
    path: "views/DashboardItemBooleanConfigurationView.js",
    module: () => import("./views/DashboardItemBooleanConfigurationView.js"),
  },
  {
    path: "views/DashboardItemBooleanView.js",
    module: () => import("./views/DashboardItemBooleanView.js"),
  },
  {
    path: "views/DashboardItemConfigurationView.js",
    module: () => import("./views/DashboardItemConfigurationView.js"),
  },
  {
    path: "views/DashboardView.js",
    module: () => import("./views/DashboardView.js"),
  },
  { path: "views/DemoModal.js", module: () => import("./views/DemoModal.js") },
  {
    path: "views/GroupAddView.js",
    module: () => import("./views/GroupAddView.js"),
  },
  {
    path: "views/GroupApplyRulesView.js",
    module: () => import("./views/GroupApplyRulesView.js"),
  },
  {
    path: "views/GroupDropdownView.js",
    module: () => import("./views/GroupDropdownView.js"),
  },
  {
    path: "views/GroupSelectorView.js",
    module: () => import("./views/GroupSelectorView.js"),
  },
  { path: "views/GroupView.js", module: () => import("./views/GroupView.js") },
  {
    path: "views/IMEILockMismatchCalloutView.js",
    module: () => import("./views/IMEILockMismatchCalloutView.js"),
  },
  {
    path: "views/IMEILockUnlockView.js",
    module: () => import("./views/IMEILockUnlockView.js"),
  },
  {
    path: "views/ImportDeckGL.js",
    module: () => import("./views/ImportDeckGL.js"),
  },
  {
    path: "views/InternalView.js",
    module: () => import("./views/InternalView.js"),
  },
  { path: "views/Json.js", module: () => import("./views/Json.js") },
  {
    path: "views/LegacyGroupPathView.js",
    module: () => import("./views/LegacyGroupPathView.js"),
  },
  {
    path: "views/LoraRegisterView.js",
    module: () => import("./views/LoraRegisterView.js"),
  },
  {
    path: "views/LoraSystemInfoDashboardItemView.js",
    module: () => import("./views/LoraSystemInfoDashboardItemView.js"),
  },
  {
    path: "views/NotificationTemplateListView.js",
    module: () => import("./views/NotificationTemplateListView.js"),
  },
  {
    path: "views/PageContextFilterView.js",
    module: () => import("./views/PageContextFilterView.js"),
  },
  { path: "views/SignUp.js", module: () => import("./views/SignUp.js") },
  {
    path: "views/ViewExample.js",
    module: () => import("./views/ViewExample.js"),
  },
  { path: "views/VpnView.js", module: () => import("./views/VpnView.js") },
];
